<template>
  <div>
    <ul class="">
      <li
        v-for="(value, key) in jsonData"
        :key="key"
        class=" whitespace-normal text-sm mb-1"
      >
        <span class="font-medium text-gray-500 me-1">{{ toProperCase(key.replace(/_/g, ' ')) }}:</span>
        <span v-if="!isExpandable(value)" class="text-gray-700">
          {{ value }}
        </span>
        <div
          v-if="isExpandable(value) && expanded[key]"
          class="ml-4 border-l pl-2 mt-1"
        >
          <component :is="$options.name" :json-data="value" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { toProperCase } from '@/utils/common';

export default {
  name: 'DataTreeViewer',
  props: {
    jsonData: {
      type: [Object, Array],
      required: true,
    },
  },
  data() {
    return {
      expanded: {},
    };
  },
  methods: {
    toProperCase,
    toggleExpand(key) {
      this.expanded[key] = !this.expanded[key];
    },
    isExpandable(item) {
      return item !== null && typeof item === 'object';
    },
  },
};
</script>
